<mat-form-field class="block w-full mat-form-field-no-padding" floatLabel="always">
  <mat-label>{{ 'settings.uiLanguage' | translate }}</mat-label>
  <mat-select [value]="appLanguage" (selectionChange)="setLanguage($event)">
    @for (entry of allLanguages; track $index) {
      <mat-option [value]="entry">{{ languageMap[entry].name }}</mat-option>
    }
  </mat-select>
</mat-form-field>
<p class="setting-description" [innerHTML]="'settings.uiLanguageDescription' | translate"></p>
